export default __webpack_public_path__ + "static/media/lawdisk-premium-bg.2ff1f59b.png";